import { FC } from 'react';

import GiftDirectCheckoutPage from '@service/giftStore/page/GiftDirectCheckoutPage';
import GiftItemDetailPage from '@service/giftStore/page/GiftItemDetailPage';
import { Navigate, Route, Routes } from 'react-router-dom';

const GiftItemIdRouter: FC = () => {
  return (
    <Routes>
      <Route path="" element={<GiftItemDetailPage />} />
      <Route path="checkout" element={<GiftDirectCheckoutPage />} />
      <Route path="*" element={<Navigate to="/gift-store" />} />
    </Routes>
  );
};

export default GiftItemIdRouter;
